export default [
  { country: 'Argentina', code: 'es-AR' },
  { country: 'Australia', code: 'en-AU' },
  { country: 'Austria', code: 'de-AT' },
  { country: 'Bangladesh', code: 'bn-BD' },
  { country: 'Belgium (Dutch)', code: 'nl-BE' },
  { country: 'Belgium (French)', code: 'fr-BE' },
  { country: 'Brazil', code: 'pt-BR' },
  { country: 'Canada (English)', code: 'en-CA' },
  { country: 'Canada (French)', code: 'fr-CA' },
  { country: 'Chile', code: 'es-CL' },
  { country: 'China', code: 'zh-CN' },
  { country: 'Columbia', code: 'es-CO' },
  { country: 'Czech Republic', code: 'cs-CZ' },
  { country: 'Denmark', code: 'da-DK' },
  { country: 'Finland', code: 'fi-FI' },
  { country: 'France', code: 'fr-FR' },
  { country: 'Germany', code: 'de-DE' },
  { country: 'Greece', code: 'el-GR' },
  { country: 'Hond Kong', code: 'zh-HK' },
  { country: 'Hungary', code: 'hu-HU' },
  { country: 'India (Bengali)', code: 'bn-IN' },
  { country: 'India (English)', code: 'en-IN' },
  { country: 'India (Hindi)', code: 'hi-IN' },
  { country: 'India (Tamil)', code: 'ta-IN' },
  { country: 'Indonesia', code: 'id-ID' },
  { country: 'Ireland', code: 'en-IE' },
  { country: 'Israel', code: 'he-IL' },
  { country: 'Italy', code: 'it-IT' },
  { country: 'Japan', code: 'jp-JP' },
  { country: 'Mexico', code: 'es-MX' },
  { country: 'Netherlands', code: 'nl-NL' },
  { country: 'New Zealand', code: 'en-NZ' },
  { country: 'Norway', code: 'no-NO' },
  { country: 'Poland', code: 'pl-PL' },
  { country: 'Portugal', code: 'pt-PT' },
  { country: 'Republic of Korea', code: 'ko-KR' },
  { country: 'Romania', code: 'ro-RO' },
  { country: 'Russia', code: 'ru-RU' },
  { country: 'Saudi Arabia', code: 'ar-SA' },
  { country: 'Slovakia', code: 'sk-SK' },
  { country: 'South Africa', code: 'en-ZA' },
  { country: 'Spain', code: 'es-ES' },
  { country: 'Sri Lanka', code: 'ta-LK' },
  { country: 'Sweden', code: 'sv-SE' },
  { country: 'Switzerland (German)', code: 'de-CH' },
  { country: 'Switzerland (French)', code: 'fr-CH' },
  { country: 'Switzerland (Italian)', code: 'it-CH' },
  { country: 'Taiwan', code: 'zh-TW' },
  { country: 'Thailand', code: 'th-TH' },
  { country: 'Turkey', code: 'tr-TR' },
  { country: 'United Kingdom', code: 'en-GB' },
  { country: 'United States', code: 'en-US' },
  { country: 'United States (Spanish)', code: 'es-US' },
];
